import useLabel from 'app/hooks/useLabel'

import useStyles from './CustomTooltip.styles'

const CustomTooltip = ({
    date,
    maxTrucksPerDay,
    inboundOrdersTrucksAmount,
    outboundOrdersTrucksAmount,
    inboundOrders,
    outboundOrders,
    classNames,
}: {
    date: string,
    maxTrucksPerDay: number,
    inboundOrdersTrucksAmount: number,
    outboundOrdersTrucksAmount: number,
    inboundOrders: number,
    outboundOrders: number,
    classNames: Record<string, string>,
}) => {
    const {
        classes,
        cx,
    } = useStyles()

    const l = useLabel()

    return (
        <div
            className={classes.tooltipWrapper}
            data-testid="tooltip"
        >
            <div className={classes.wrapper}>
                <div className={classes.item}>
                    <div className={classes.label}>{l('Monitoring.date')}</div>
                    <div>{date}</div>
                </div>
                <div className={classes.item}>
                    <div className={classes.label}>{l('Monitoring.maxTrucksPerDay')}</div>
                    <div>{maxTrucksPerDay}</div>
                </div>
            </div>
            <div className={classes.wrapper}>
                <div className={classes.item}>
                    <div className={classes.label}>{l('Monitoring.inboundOrdersAmount')}</div>
                    <div>{inboundOrders}</div>
                </div>
                <div className={classes.item}>
                    <div className={classes.label}>{l('Monitoring.outboundOrdersAmount')}</div>
                    <div>{outboundOrders}</div>
                </div>
            </div>
            <div className={classes.wrapper}>
                <div className={classes.item}>
                    <div className={classes.label}>{l('Monitoring.inboundOrdersTrucksAmount')}</div>
                    <div className={classes.valueWrapper}>
                        <div
                            className={cx(classes.marker, classNames.inbound)}
                        />
                        <div>{inboundOrdersTrucksAmount}</div>
                    </div>
                </div>
                <div className={classes.item}>
                    <div className={classes.label}>{l('Monitoring.outboundOrdersTrucksAmount')}</div>
                    <div className={classes.valueWrapper}>
                        <div
                            className={cx(classes.marker, classNames.outbound)}
                        />
                        <div>{outboundOrdersTrucksAmount}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CustomTooltip
